import { AssetSubClassCode, Entity } from '@toggle/toggle';

import { ResampleIntervals } from '~/types/resample.types';
import type { SeriesType } from '~/types/series.types';

export const isFXEntity = (entity: Entity): boolean => {
  return (
    entity.sub_class === AssetSubClassCode.MajorCross ||
    entity.sub_class === AssetSubClassCode.GenericCross
  );
};

export const isCommodityEntity = (entity: Entity): boolean => {
  return (
    entity.sub_class === AssetSubClassCode.FutureEnergy ||
    entity.sub_class === AssetSubClassCode.FutureFood ||
    entity.sub_class === AssetSubClassCode.FutureGrains ||
    entity.sub_class === AssetSubClassCode.FutureMetals ||
    entity.sub_class === AssetSubClassCode.FutureSofts
  );
};

export const isResampleOneDayOrGreater = (
  selectedResample: ResampleIntervals | undefined
): boolean => {
  if (!selectedResample) {
    return false;
  }

  const nonIntradayResamples = [
    ResampleIntervals.OneDay,
    ResampleIntervals.OneWeek,
    ResampleIntervals.OneMonth,
  ];

  return nonIntradayResamples.includes(selectedResample);
};

export const isChartTypeNotSupportedForFX = (
  entity: Entity,
  selectedResample: ResampleIntervals | undefined,
  chartType: SeriesType
): boolean => {
  if (!isFXEntity(entity)) {
    return false;
  }

  const isCandlestickOrBars = ['bars', 'candlestick'].includes(chartType);

  return isResampleOneDayOrGreater(selectedResample) && isCandlestickOrBars;
};

export const isChartTypeNotSupportedForCommodity = (
  entity: Entity,
  selectedResample: ResampleIntervals | undefined,
  chartType: SeriesType
): boolean => {
  if (!isCommodityEntity(entity)) {
    return false;
  }

  const isCandlestickOrBars = ['bars', 'candlestick'].includes(chartType);

  return isResampleOneDayOrGreater(selectedResample) && isCandlestickOrBars;
};
